import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <>
      <h2 className="font-bold text-4xl text-center pt-10 tracking-widest text-gray-800">
        Routes and Deliveries
      </h2>
      <section className="px-5 pt-10 pb-20 sm:grid sm:grid-cols-2 sm:gap-5 xl:px-32 2xl:px-56">
        <div className="bg-blue-100 mb-6 text-center py-4 px-8 rounded text-gray-800 font-bold leading-10">
          <p className="font-bold text-3xl">
            Routes{' '}
            <span className="block font-bold text-xl mt-4 ">
              Parklands, Nairobi City, Syokimau, Mlolongo, Kitengela, Athi River
            </span>
          </p>
          <Link
            to="/routes"
            className="block mt-5 bg-gray-800 text-white border rounded transition-all hover:bg-white hover:text-gray-800"
          >
            See All Routes
          </Link>
        </div>

        <div className="bg-blue-100 mb-6 text-center py-4 px-8 rounded text-gray-800 font-bold">
          <p className="font-bold text-4xl">
            125{' '}
            <span className="block text-xl font-bold mt-4">
              Deliveries Made
            </span>
          </p>
        </div>
      </section>
    </>
  )
}

export default Services
